import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const ProfileTabs = (props) => {
	useStyles(css);
	const { tabs, onClickTab } = props;

	if (tabs.length === 0) return null;

	return (
		<div className={css.wrap}>
			{tabs.map((tab) => (
				<button
					type="button"
					className={cn(css.tab, {
						[css['tab--status--active']]: tab.isActive,
					})}
					onClick={() => onClickTab(tab)}
					disabled={tab.isDisabled}
					key={tab.id}
				>
					{tab.label}
				</button>
			))}
		</div>
	);
};

ProfileTabs.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			label: PropTypes.string,
			isActive: PropTypes.bool,
			isDisabled: PropTypes.bool,
		}),
	).isRequired,
	onClickTab: PropTypes.func.isRequired,
};

export default ProfileTabs;
